  import { Component, OnInit, signal } from '@angular/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Masks, MaskService } from '../../../shared/services/mask.service';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { cnpjValidator } from '../../../shared/validators/cnpj.validator';
import { EmpresaService } from '../../../shared/services/apis/usuario/empresa.service';
import { EmpresaResponse } from '../../../shared/services/responses/usuario/empresa.response';
import { EmpresaRequest } from '../../../shared/services/requests/usuario/empresa.request';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { forkJoin, Observable } from 'rxjs';
import { TimezoneService } from '../../../shared/services/apis/usuario/timezone.service';
import { ListaTimezoneResponse } from '../../../shared/services/responses/usuario/lista-timezone.response';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmpresaGrupoService } from '../../../shared/services/apis/usuario/empresa-grupo.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ModuloService } from '../../../shared/services/apis/usuario/modulo.service';
import { ListaModulosResponse } from '../../../shared/services/responses/usuario/lista-modulos.response';
import { Modulo } from '../../../shared/services/models/usuario/modulo.model';
import { cpfValidator } from '../../../shared/validators/cpf.validator';
import { emailValidator } from '../../../shared/validators/email.validator';
import { UsuarioService } from '../../../shared/services/apis/usuario/usuario.service';
import { UsuarioResponse } from '../../../shared/services/responses/usuario/usuario.response';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { Usuario } from '../../../shared/services/models/usuario/usuario.model';
import { LookupEmpresaGrupoResponse } from '../../../shared/services/responses/usuario/lookup-empresa-grupo.response';
import { environment } from '../../../../environments/environment';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { Timezone } from '../../../shared/services/models/usuario/timezone.model';
import { UsuarioLookupService } from '../../../shared/services/apis/usuario/usuario-lookup.service';
import { UsuarioListaLookupsResponse } from '../../../shared/services/responses/usuario/usuario-lista-lookups.response';
import { UnidadeFederativa } from '../../../shared/services/models/usuario/unidade-federativa.model';
import { CasasDecimaisRequest } from '../../../shared/services/requests/usuario/casas-decimais.request';
import { CasasDecimaisResponse } from '../../../shared/services/responses/usuario/casas-decimais.response';
import { EmpresaCadastroResponse } from '../../../shared/services/responses/usuario/empresa-cadastro.response';
import { CEPCorreios, UtilService } from '../../../shared/services/util.service';
import { SelectPesquisavelService } from '../../../shared/components/select-pesquisavel/select-pesquisavel.service';
import { Municipio } from '../../../shared/services/models/usuario/municipio.model';
import { EmpresaLogoEdicaoStruct } from '../../../shared/services/structs/usuario/empresa-logo-edicao.struct';
import { TipoLogoEmpresa } from '../../../shared/enums/tipo-logo-empresa.enum';
import {
  EmpresaLogoDialogComponent,
  EmpresaLogoDialogData,
  EmpresaLogoDialogResult,
} from '../../../shared/components/empresa-logo-dialog/empresa-logo-dialog.component';
import { MotorFiscalLookupService } from '../../../shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { LookupItemStruct } from '../../../shared/services/structs/motor-fiscal/lookup-item.struct';
import { RegimeTributarioEnum } from '../../../shared/enums/motor-fiscal/regime-tributario.enum';
import { SituacaoContribuinteEmpresaEnum } from '../../../shared/enums/situacao-contribuinte-empresa.enum';

@Component({
  selector: 'app-empresa-cadastro',
  imports: [
    NgxMaskDirective,
    MenuComponent,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    RouterModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatSelectModule,
    SelectPesquisavelComponent,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './empresa-cadastro.component.html',
  styleUrl: './empresa-cadastro.component.css',
  providers: [provideNgxMask()],
})
export class EmpresaCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private empresaService: EmpresaService,
    private timezoneService: TimezoneService,
    private empresaGrupoService: EmpresaGrupoService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private maskService: MaskService,
    private moduloService: ModuloService,
    private usuarioService: UsuarioService,
    private usuarioLookupService: UsuarioLookupService,
    private utilService: UtilService,
    private selectPesquisavelService: SelectPesquisavelService,
    private motorFiscalLookupService: MotorFiscalLookupService
  ) {
    this.moduloEnum = ModuloEnum.Implantacao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Implantacao_Empresa;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public masks: Masks;

  public idEmpresa: number | null = null;
  public _empresaResponse: EmpresaResponse;
  public empresaGrupoResponse: LookupEmpresaGrupoResponse;
  // public _timezoneLookupResponse: ListaTimezoneResponse;
  public listaTimezoneFiltrado: Observable<Timezone[]>;
  public listTimezone: Timezone[];
  public _listaModulos: Modulo[];
  public _listaUnidadeFederativa: UnidadeFederativa[];
  public btnSalvarDisable: boolean = false;
  public idUsuarioMaster: number | null;
  public _isLoadingBusca: boolean = false;
  public isLoadingCep: boolean = false;
  public preloadedMunicipio: any[] = [];

  // Estado local da logo. Persistido apenas no submit junto do EmpresaRequest.
  public logoUrlPreview: string | null = null;
  private logoUrlOriginal: string | null = null;
  private logoEdicao: EmpresaLogoEdicaoStruct | null = null;
  private logoBlobUrlAtivo: string | null = null;
  public usuario: Usuario | null;
  public alterarMaster: boolean = false;
  public urlListEmpresaGrupo: string;
  public urlListRevenda: string;
  public urlListMunicipio: string | null = null;
  public preloadedGrupoEmpresa: any[];
  public preloadedRevenda: any[];
  public preloadedTimezone: any[];
  public preloadedUnidadeFederativa: any[];
  public disableSave: boolean = true;

  // Dados fiscais.
  // Data de fundação não pode ser futura — trava o datepicker e o campo digitado.
  public readonly dataMaxima: Date = new Date();
  public listaRegimeTributario: LookupItemStruct[] = [];
  public cnaeLookupUrl: string = '';
 
  public preloadedCnae: LookupItemStruct[] = [];
  public listaRegimeApuracaoIrpj: LookupItemStruct[] = [];
  /** Situações do contribuinte da empresa (ids de SituacaoContribuinteEmpresaEnum). */
  public listaSituacaoContribuinteEmpresa: LookupItemStruct[] = [];

  /** Linha de ajuda de cada situação. Mesmos textos de Configurações > Empresa no Workspace. */
  private readonly textoAjudaSituacaoContribuinteEmpresa: Record<SituacaoContribuinteEmpresaEnum, string> = {
    [SituacaoContribuinteEmpresaEnum.NaoContribuinteIcms]:
      'A empresa não apura ICMS e não tem Inscrição Estadual.',
    [SituacaoContribuinteEmpresaEnum.ContribuinteIcms]:
      'A empresa apura ICMS e tem Inscrição Estadual ativa no estado.',
    [SituacaoContribuinteEmpresaEnum.ContribuinteExclusivoIbsCbs]:
      'A empresa paga os novos tributos da Reforma Tributária (IBS e CBS), mas não apura ICMS.',
  };

  /** O que muda com o enquadramento exclusivo de IBS/CBS (card abaixo dos dados fiscais). */
  public readonly frasesEnquadramentoContribuinteExclusivoIbsCbs: readonly string[] = [
    'As notas fiscais da empresa passam a ser enviadas pela SEFAZ Virtual do Rio Grande do Sul (SVRS).',
    'Revise as naturezas de operação: as notas desta empresa não destacam ICMS.',
    'Enquanto as regras atuais estiverem em vigor, a empresa não pode emitir NFC-e (nota fiscal de consumidor).',
    'Enquanto as regras atuais estiverem em vigor, não é possível informar inscrição estadual de substituto tributário.',
  ];

  /**
   * Três estados, e a diferença importa: `true` regime com apuração do IRPJ (Regime Normal ou Simples
   * Nacional com excesso de sublimite), `false` outro regime, `null` NÃO SEI.
   *
   * O regime é um id lógico do db_motor_fiscal e quem identifica o regime é o `codigo` da
   * lookup, não o id. Enquanto a lista não chega — ou se voltar vazia, o que acontece em silêncio
   * quando o lookup falha — não há como classificar o regime gravado. Tratar esse caso como `false`
   * faria o envio apagar a apuração gravada num Salvar que nem tocou nesses campos.
   */
  private get classificacaoRegime(): boolean | null {
    const idRegime = this.model?.get('idRegimeTributario')?.value ?? null;
    if (idRegime == null) return false;

    const codigo = this.listaRegimeTributario.find(x => x.id === idRegime)?.codigo;
    if (codigo === undefined) return null;

    return codigo === RegimeTributarioEnum.RegimeNormal.toString()
      || codigo === RegimeTributarioEnum.SimplesNacionalExcessoSublimite.toString();
  }

  /** Só `true` quando o regime foi reconhecido como um regime com apuração - controla a exibição do campo. */
  public get usaRegimeApuracao(): boolean {
    return this.classificacaoRegime === true;
  }

  ngOnInit(): void {
    this.urlListEmpresaGrupo = environment.urlApiUsuario + 'EmpresaGrupo/admin/lookup';
    this.urlListRevenda = environment.urlApiUsuario + 'Revenda/admin/lookup';
    this.masks = this.maskService.getMasks();
    if (this.activatedRoute.snapshot.params['id']) {
      this.idEmpresa = parseInt(this.activatedRoute.snapshot.params['id'] ?? '');
    }

    this.model = this.formBuilder.group({
      nomeEmpresa: [{ value: '', disabled: false }, [Validators.required, requiredTrim]],
      listaTimezone: ['', Validators.required],
      cnpj: [{ value: '', disabled: false }, [Validators.required, cnpjValidator()]],
      inscricaoEstadual: [''],
      isAtivo: [{ value: true, disabled: false }],

      nomeFantasia: [null, [Validators.maxLength(100)]],
      dataFundacao: [null],
      cnaePrincipal: [null],
      idRegimeTributario: [null],
      idRegimeApuracaoIrpj: [null],
      idSituacaoContribuinteEmpresa: [SituacaoContribuinteEmpresaEnum.ContribuinteIcms as number],
      inscricaoMunicipal: [null],
      inscricaoSuframa: [null],
      idEmpresaGrupo: [null],
      idRevenda: [null],
      listaIdModulos: [[]],
      idUnidadeFederativa: [null, Validators.required],
      idMunicipio: [{ value: null, disabled: true }, Validators.required],
      cep: ['', [Validators.required, Validators.pattern(/^\d{5}-?\d{3}$/)]],
      logradouro: ['', [Validators.required, requiredTrim]],
      numero: ['', [Validators.required, requiredTrim]],
      complemento: [''],
      bairro: ['', [Validators.required, requiredTrim]],
      casasDecimaisPreco: [2, [Validators.required, Validators.min(2), Validators.max(10)]],
      casasDecimaisQuantidade: [2, [Validators.required, Validators.min(2), Validators.max(4)]],
      email: [{ value: '', disabled: false }, [Validators.required, emailValidator()]],
      nomeUsuario: [{ value: '', disabled: true }, [Validators.required, requiredTrim]],
      telefone: [{ value: '', disabled: true }],
      cpf: [{ value: '', disabled: true }, [Validators.required, cpfValidator()]],
      senha: [{ value: '', disabled: true }, [Validators.required]],
      alterarMaster: [false],
    });

    this.cnaeLookupUrl = this.motorFiscalLookupService.cnaeLookupUrl;
    this.motorFiscalLookupService
      .getRegimesTributarios()
      .subscribe(lista => (this.listaRegimeTributario = lista));

    this.motorFiscalLookupService
      .getRegimesApuracaoIrpj()
      .subscribe(lista => (this.listaRegimeApuracaoIrpj = lista));

    this.motorFiscalLookupService
      .getSituacoesContribuinteEmpresa()
      .subscribe(lista => (this.listaSituacaoContribuinteEmpresa = lista));

    this.idSituacaoContribuinteEmpresaControl.valueChanges.subscribe(() => this.onSituacaoContribuinteEmpresaChange());

    // Trocar o regime invalida a apuração escolhida para o regime anterior.
    this.model
      .get('idRegimeTributario')
      ?.valueChanges.subscribe(() =>
        this.model.get('idRegimeApuracaoIrpj')?.setValue(null, { emitEvent: false })
      );

    // this.lookupEmpresaGrupo();
    this.listarLookups();
  }

  listarLookups() {
    this.usuarioLookupService.get().subscribe({
      next: (response: UsuarioListaLookupsResponse) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listTimezone = response.listaTimezone;
        this._listaModulos = response.listaModulos;
        this._listaUnidadeFederativa = response.listaUnidadeFederativa.map(uf => ({
          ...uf,
          descricaoExibicao: `${uf.nome} - ${uf.uf}`,
        }));

        if (this.idEmpresa) {
          this.disableSave = false;
          this.popularDadosEmpresa();
        }
      },
      error: error => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  popularDadosEmpresa() {
    this._isLoading = true;
    forkJoin({
      empresaResponse: this.empresaService.ObterPorId(this.idEmpresa ?? 0),
      casasDecimaisResponse: this.empresaService.ObterCasasDecimaisPorId(this.idEmpresa ?? 0),
    }).subscribe({
      next: ({ empresaResponse, casasDecimaisResponse }: { empresaResponse: EmpresaResponse; casasDecimaisResponse: CasasDecimaisResponse }) => {
        if (empresaResponse.isError) {
          this.alertService.show('Erro', empresaResponse.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }

        if (casasDecimaisResponse.isError) {
          this.alertService.show('Erro', casasDecimaisResponse.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }

        this.model.get('nomeEmpresa')?.setValue(empresaResponse.empresa.nomeEmpresa);
        this.model.get('cnpj')?.setValue(empresaResponse.empresa.cnpj);
        this.model.get('inscricaoEstadual')?.setValue(empresaResponse.empresa.inscricaoEstadual);
        this.model.get('isAtivo')?.setValue(empresaResponse.empresa.isAtivo);
        this.model.get('listaTimezone')?.setValue(empresaResponse.empresa.idTimezone);
        this.model.get('casasDecimaisPreco')?.setValue(casasDecimaisResponse.casasDecimaisPreco);
        this.model.get('casasDecimaisQuantidade')?.setValue(casasDecimaisResponse.casasDecimaisQuantidade);

        // Dados fiscais.
        this.model.get('nomeFantasia')?.setValue(empresaResponse.empresa.nomeFantasia ?? null);
        this.model
          .get('dataFundacao')
          ?.setValue(this.converterDataApiParaDate(empresaResponse.empresa.dataFundacao ?? null));
        // `emitEvent: false` no regime: o valueChanges limparia a apuração que vamos gravar na
        // linha seguinte.
        this.model
          .get('idRegimeTributario')
          ?.setValue(empresaResponse.empresa.idRegimeTributario ?? null, { emitEvent: false });
        this.model
          .get('idRegimeApuracaoIrpj')
          ?.setValue(empresaResponse.empresa.idRegimeApuracaoIrpj ?? null);
        // `emitEvent: false`: a carga não é escolha do usuário, então não limpa nem exige a inscrição.
        this.idSituacaoContribuinteEmpresaControl.setValue(
          empresaResponse.empresa.idSituacaoContribuinteEmpresa ?? SituacaoContribuinteEmpresaEnum.ContribuinteIcms,
          { emitEvent: false }
        );
        this.model
          .get('inscricaoMunicipal')
          ?.setValue(empresaResponse.empresa.inscricaoMunicipal ?? null);
        this.model
          .get('inscricaoSuframa')
          ?.setValue(empresaResponse.empresa.inscricaoSuframa ?? null);
        this.aplicarEstadoInscricaoEstadual(false);
        this.carregarCnaeSelecionado(empresaResponse.empresa.cnaePrincipal ?? null);

        // Define o valor no form control
        this.model.get('idEmpresaGrupo')?.setValue(empresaResponse.empresa.empresaGrupo?.idEmpresaGrupo);

        // Prepara o objeto para o [preloadedOptions] do select
        if (empresaResponse.empresa.empresaGrupo) {
          this.preloadedGrupoEmpresa = [empresaResponse.empresa.empresaGrupo];
        }
        if (empresaResponse.empresa.idTimezone) {
          this.preloadedTimezone = [
            ...this.listTimezone?.filter(x => x.idTimezone == empresaResponse.empresa.idTimezone),
          ];
        }

        this.model.get('email')?.setValue(empresaResponse.usuarioMaster.email);
        this.model.get('nomeUsuario')?.setValue(empresaResponse.usuarioMaster.nomeUsuario);
        this.model.get('telefone')?.setValue(empresaResponse.usuarioMaster.telefone);
        this.model.get('cpf')?.setValue(empresaResponse.usuarioMaster.cpf);
        this.model.get('listaIdModulos')?.setValue(empresaResponse.listaIdsModulosSelecionadosEmpresa);
        if (empresaResponse.usuarioMaster.idUsuario) {
          this.idUsuarioMaster = empresaResponse.usuarioMaster.idUsuario;
          this.model.get('senha')?.setValidators(null);
          this.model.get('senha')?.updateValueAndValidity();
          this.model.get('cpf')?.disable();
          this.model.get('email')?.disable();
        }

        // Endereco agora vem plano dentro do objeto `empresa` (a tabela `empresa_endereco` foi extinta).
        const empresa = empresaResponse.empresa;
        if (empresa.idUnidadeFederativa) {
          this.model.get('idUnidadeFederativa')?.setValue(empresa.idUnidadeFederativa);
          this.preloadedUnidadeFederativa = [
            ...this._listaUnidadeFederativa.filter(
              x => x.idUnidadeFederativa == empresa.idUnidadeFederativa
            ),
          ];

          this.model.get('idMunicipio')?.setValue(empresa.idMunicipio);
          this.model.get('idMunicipio')?.enable();
          this.urlListMunicipio =
            environment.urlApiUsuario +
            `Municipio/admin/idUnidadeFederativa/${empresa.idUnidadeFederativa}`;

          if (empresa.idMunicipio && empresa.municipio) {
            this.preloadedMunicipio = [{
              idMunicipio: empresa.idMunicipio,
              nome: empresa.municipio,
              idUnidadeFederativa: empresa.idUnidadeFederativa,
            }];
          }
        }

        this.model.get('cep')?.setValue(empresa.cep ?? '');
        this.model.get('logradouro')?.setValue(empresa.logradouro ?? '');
        this.model.get('numero')?.setValue(empresa.numero ?? '');
        this.model.get('complemento')?.setValue(empresa.complemento ?? '');
        this.model.get('bairro')?.setValue(empresa.bairro ?? '');

        if (empresaResponse.empresa.idRevenda) {
          this.model.get('idRevenda')?.setValue(empresaResponse.empresa.idRevenda);
          if (empresaResponse.empresa.revenda) {
            this.preloadedRevenda = [empresaResponse.empresa.revenda];
          }
        }
        // Em modo edição a revenda fica desabilitada para evitar troca acidental.
        this.model.get('idRevenda')?.disable();

        // Hoje usamos a logo Principal. Quando novos tipos forem suportados,
        // basta filtrar pelo enum `TipoLogoEmpresa` desejado.
        const logos = empresaResponse.empresa.logos ?? [];
        const logoPrincipal =
          logos.find(l => l.tipo === TipoLogoEmpresa.Principal) ?? logos[0] ?? null;
        this.logoUrlOriginal = logoPrincipal?.urlLogo ?? null;
        this.logoUrlPreview = this.logoUrlOriginal;
        this.logoEdicao = null;

        this._empresaResponse = empresaResponse;
        this.model.get('cnpj')?.disable();
        if (this._empresaResponse.empresa.empresaGrupo) {
          this.model.get('idEmpresaGrupo')?.disable();
        } else {
          this.model.get('idEmpresaGrupo')?.enable();
        }

        this._isLoading = false;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  submit(): void {
    if (this._isLoading) {
      return;
    }

    if (this.model.invalid) {
      this.model.markAllAsTouched();
      return;
    }

    const empresaRequest: EmpresaRequest = new EmpresaRequest();
    const casasDecimaisRequest: CasasDecimaisRequest = this.obterCasasDecimaisRequest();

    empresaRequest.idEmpresa = this.idEmpresa;
    empresaRequest.nomeEmpresa = this.model.get('nomeEmpresa')?.value;
    empresaRequest.idEmpresaGrupo = this.model?.get('idEmpresaGrupo')?.value;
    empresaRequest.idRevenda = this.model?.get('idRevenda')?.value ?? null;
    empresaRequest.cnpj = this.model.get('cnpj')?.value;
    empresaRequest.isAtivo = this.model.get('isAtivo')?.value;

    // Dados fiscais. Fora de contribuinte de ICMS a Inscrição Estadual sempre vai nula no envio,
    // mesmo que o campo já estivesse desabilitado com algum valor.
    empresaRequest.nomeFantasia = this.normalizarTexto(this.model.get('nomeFantasia')?.value);
    empresaRequest.dataFundacao = this.converterDateParaDataApi(this.model.get('dataFundacao')?.value ?? null);
    empresaRequest.cnaePrincipal = this.normalizarCnae(this.model.get('cnaePrincipal')?.value);
    empresaRequest.idRegimeTributario = this.model.get('idRegimeTributario')?.value ?? null;
    // Zera só quando o regime foi reconhecido e não tem apuração do IRPJ - aí a apuração não se
    // aplica. Com o regime não classificado (`null`), reenvia o que está no formulário: apagar por
    // não saber seria perder um dado que ninguém pediu para mexer.
    empresaRequest.idRegimeApuracaoIrpj =
      this.classificacaoRegime === false
        ? null
        : (this.model.get('idRegimeApuracaoIrpj')?.value ?? null);
    empresaRequest.idSituacaoContribuinteEmpresa = this.idSituacaoContribuinteEmpresaControl.value;
    empresaRequest.inscricaoEstadual = this.isContribuinteIcms
      ? this.normalizarTexto(this.model.get('inscricaoEstadual')?.value)
      : null;
    empresaRequest.inscricaoMunicipal = this.normalizarTexto(this.model.get('inscricaoMunicipal')?.value);
    empresaRequest.inscricaoSuframa = this.normalizarTexto(this.model.get('inscricaoSuframa')?.value);
    empresaRequest.idTimezone = this.model.get('listaTimezone')?.value;

    // Endereco plano direto no request - vive em `empresa` desde a refatoracao.
    empresaRequest.cep = this.model.get('cep')?.value ?? null;
    empresaRequest.logradouro = this.model.get('logradouro')?.value ?? null;
    empresaRequest.numero = this.model.get('numero')?.value ?? null;
    empresaRequest.complemento = this.model.get('complemento')?.value ?? null;
    empresaRequest.bairro = this.model.get('bairro')?.value ?? null;
    empresaRequest.idUnidadeFederativa = this.model.get('idUnidadeFederativa')?.value ?? null;
    empresaRequest.idMunicipio = this.model.get('idMunicipio')?.value ?? null;

    empresaRequest.emailMaster = this.model.get('email')?.value;
    empresaRequest.nomeUsuarioMaster = this.model.get('nomeUsuario')?.value;
    empresaRequest.telefoneMaster = this.model.get('telefone')?.value;
    empresaRequest.cpfMaster = this.model.get('cpf')?.value;
    empresaRequest.senha = this.model.get('senha')?.value;
    empresaRequest.listaIdModuloAcesso = this.model.get('listaIdModulos')?.value;
    empresaRequest.alterarMaster = this.model.get('alterarMaster')?.value;

    empresaRequest.idUsuarioMaster = this.usuario ? this.usuario.idUsuario : this.idUsuarioMaster;

    empresaRequest.logo = this.logoEdicao;

    if (!this.model.get('listaTimezone')?.value) {
      this.alertService.show('Erro', 'Selecione um timezone', AlertType.error);
      return;
    }

    if (this.logoEdicao && this.logoEdicao.arquivoBase64 && !this.logoEdicao.extensao) {
      this.alertService.show('Erro', 'Arquivo de logo inválido.', AlertType.error);
      return;
    }

    this.prepararLogoBase64()
      .then(() => {
        empresaRequest.logo = this.logoEdicao;
        if (!this.idEmpresa) {
          this.novo(empresaRequest, casasDecimaisRequest);
        } else {
          this.alterar(empresaRequest, casasDecimaisRequest);
        }
      })
      .catch(() => {
        this.alertService.show('Erro', 'Falha ao preparar a logo para envio.', AlertType.error);
      });
  }

  /**
   * Abre o dialog para visualizar/trocar/remover a logo. Persistencia ocorre apenas no submit.
   */
  abrirDialogLogo(): void {
    const dialogRef = this.dialog.open<EmpresaLogoDialogComponent, EmpresaLogoDialogData, EmpresaLogoDialogResult>(
      EmpresaLogoDialogComponent,
      {
        data: { urlLogoAtual: this.logoUrlPreview ?? this.logoUrlOriginal },
        width: '640px',
        maxWidth: '95vw',
        maxHeight: '95vh',
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      this.descartarBlobUrlLogo();

      if (result.remover) {
        this.logoUrlPreview = null;
        this.logoEdicao = {
          remover: true,
          arquivoBase64: null,
          extensao: null,
          nomeOriginal: null,
          contentType: null,
          tipo: TipoLogoEmpresa.Principal,
        };
        return;
      }

      if (result.arquivo) {
        this.logoBlobUrlAtivo = result.previewUrl;
        this.logoUrlPreview = result.previewUrl;

        const ext = (result.arquivo.name.split('.').pop() || '').toLowerCase();
        this.logoEdicao = {
          remover: false,
          arquivoBase64: null,
          extensao: ext,
          nomeOriginal: result.arquivo.name,
          contentType: result.arquivo.type || null,
          tipo: TipoLogoEmpresa.Principal,
        };
        // O base64 e gerado lazy no submit (`prepararLogoBase64`) para nao bloquear o dialog.
        (this.logoEdicao as any).__file = result.arquivo;
      }
    });
  }

  private prepararLogoBase64(): Promise<void> {
    if (!this.logoEdicao || this.logoEdicao.remover) return Promise.resolve();
    if (this.logoEdicao.arquivoBase64) return Promise.resolve();

    const file: File | undefined = (this.logoEdicao as any).__file;
    if (!file) return Promise.resolve();

    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        // result e dataURL "data:<mime>;base64,<b64>" - separamos so a parte base64.
        const idx = result.indexOf(',');
        const base64 = idx >= 0 ? result.substring(idx + 1) : result;
        this.logoEdicao!.arquivoBase64 = base64;
        delete (this.logoEdicao as any).__file;
        resolve();
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private descartarBlobUrlLogo(): void {
    if (this.logoBlobUrlAtivo) {
      URL.revokeObjectURL(this.logoBlobUrlAtivo);
      this.logoBlobUrlAtivo = null;
    }
  }

  private novo(empresaRequest: EmpresaRequest, casasDecimaisRequest: CasasDecimaisRequest): void {
    this._isLoading = true;
    this.empresaService.Incluir(empresaRequest).subscribe({
      next: (returnStruct: EmpresaCadastroResponse) => {
        if (returnStruct.isError) {
          this._isLoading = false;
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        if (!returnStruct.idEmpresa) {
          this._isLoading = false;
          this.alertService.show(
            'Erro',
            'Empresa cadastrada, mas não foi possível identificar o registro para salvar as casas decimais.',
            AlertType.error
          );
          return;
        }

        this.idEmpresa = returnStruct.idEmpresa;
        this.model.get('cnpj')?.disable();
        this.model.get('idRevenda')?.disable();

        this.salvarCasasDecimais(
          returnStruct.idEmpresa,
          casasDecimaisRequest,
          'Empresa cadastrada com sucesso!',
          'Empresa cadastrada, mas não foi possível salvar as casas decimais.'
        );
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private alterar(empresaRequest: EmpresaRequest, casasDecimaisRequest: CasasDecimaisRequest): void {
    this._isLoading = true;
    this.empresaService.Alterar(this.idEmpresa ?? 0, empresaRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        if (returnStruct.isError) {
          this._isLoading = false;
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.salvarCasasDecimais(
          this.idEmpresa ?? 0,
          casasDecimaisRequest,
          'Empresa alterada com sucesso!',
          'Empresa alterada, mas não foi possível salvar as casas decimais.'
        );
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private obterCasasDecimaisRequest(): CasasDecimaisRequest {
    const casasDecimaisRequest: CasasDecimaisRequest = new CasasDecimaisRequest();
    casasDecimaisRequest.casasDecimaisPreco = Number(this.model.get('casasDecimaisPreco')?.value);
    casasDecimaisRequest.casasDecimaisQuantidade = Number(this.model.get('casasDecimaisQuantidade')?.value);
    return casasDecimaisRequest;
  }

  private salvarCasasDecimais(
    idEmpresa: number,
    casasDecimaisRequest: CasasDecimaisRequest,
    mensagemSucesso: string,
    mensagemErro: string
  ): void {
    this.empresaService.AlterarCasasDecimais(idEmpresa, casasDecimaisRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;

        if (returnStruct.isError) {
          this.alertService.show('Erro', `${mensagemErro} ${returnStruct.errorDescription}`, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', mensagemSucesso, AlertType.success);
        this.router.navigate(['/implantacao/empresa']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', `${mensagemErro} ${error.message}`, AlertType.error);
      },
    });
  }

  clickEvent(event: MouseEvent): void {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }
  hide = signal(true);

  buscarPorEmail() {
    if (!this.model?.get('email')?.value || this._isLoadingBusca) return;
    this._isLoadingBusca = true;
    this.usuarioService.getPorEmail(this.model?.get('email')?.value).subscribe({
      next: (response: UsuarioResponse) => {
        this._isLoadingBusca = false;

        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.usuario = response.usuario;
        this.disableSave = false;
        if (this.usuario) this.abrirModalUsuarioMaster();
        else {
          this.model.get('nomeUsuario')?.setValue(null);
          this.model.get('telefone')?.setValue(null);
          this.model.get('cpf')?.setValue(null);

          this.model.get('nomeUsuario')?.enable();
          this.model.get('telefone')?.enable();
          this.model.get('cpf')?.enable();
          this.model.get('senha')?.enable();
          this.model.get('senha')?.setValidators(Validators.required);
          this.model.get('senha')?.updateValueAndValidity();
          this.alertService.show(
            'Info',
            'Não há usuário cadastrado com esse email, preencha os campos para cadastrar.',
            AlertType.info
          );
        }
      },
      error: (error: any) => {
        this._isLoadingBusca = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  abrirModalUsuarioMaster(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Usuário encontrado!',
        innerHtml: `Já existe um usuário cadastrado com esse email. deseja vincular ele como master da empresa?
            </br>${this.usuario?.nomeUsuario}
            </br>${this.usuario?.cpf}
            `,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.model.get('nomeUsuario')?.setValue(this.usuario?.nomeUsuario);
          this.model.get('telefone')?.setValue(this.usuario?.telefone);
          this.model.get('cpf')?.setValue(this.usuario?.cpf);

          this.model.get('nomeUsuario')?.disable();
          this.model.get('telefone')?.disable();
          this.model.get('cpf')?.disable();
          this.model.get('senha')?.disable();
          this.model.get('senha')?.setValidators(null);
          this.model.get('senha')?.updateValueAndValidity();
        } else {
          this.model.get('email')?.setValue(null);
          this.model.get('nomeUsuario')?.setValue(null);
          this.model.get('telefone')?.setValue(null);
          this.model.get('cpf')?.setValue(null);

          this.model.get('nomeUsuario')?.enable();
          this.model.get('telefone')?.enable();
          this.model.get('cpf')?.enable();
          this.model.get('senha')?.enable();
          this.model.get('senha')?.setValidators([Validators.required]);
          this.model.get('senha')?.updateValueAndValidity();
          this.usuario = null;
        }
      },
    });
  }

  changeMaster() {
    if (this.model.get('alterarMaster')?.value) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        data: {
          title: 'Alterar Master',
          innerHtml: `Deseja realmente alterar o usuário master da empresa?`,
          buttonConfirm: 'Confirmar',
          buttonClose: 'Cancelar',
        },
      });

      dialogRef.afterClosed().subscribe({
        next: result => {
          if (result && result.confirm) {
            this.idUsuarioMaster = null;
            this.model.get('email')?.enable();
          } else {
            this.idUsuarioMaster = this._empresaResponse.usuarioMaster.idUsuario;
            this.model.get('alterarMaster')?.setValue(false);
            this.model.get('email')?.disable();
          }
        },
      });
    } else {
      this.idUsuarioMaster = this._empresaResponse.usuarioMaster.idUsuario;
      this.model.get('email')?.setValue(this._empresaResponse.usuarioMaster.email);
      this.model.get('nomeUsuario')?.setValue(this._empresaResponse.usuarioMaster.nomeUsuario);
      this.model.get('telefone')?.setValue(this._empresaResponse.usuarioMaster.telefone);
      this.model.get('cpf')?.setValue(this._empresaResponse.usuarioMaster.cpf);
      this.model.get('email')?.disable();
      this.model.get('nomeUsuario')?.disable();
      this.model.get('telefone')?.disable();
      this.model.get('cpf')?.disable();
      this.model.get('senha')?.disable();
      this.model.get('senha')?.setValidators(null);
      this.model.get('senha')?.updateValueAndValidity();
    }
  }

  changeUnidadeFederativa(idUnidadeFederativa: number | null) {
    this.model.get('idMunicipio')?.setValue(null);
    this.model.get('idMunicipio')?.disable();
    this.preloadedUnidadeFederativa = [];
    this.preloadedMunicipio = [];

    if (!idUnidadeFederativa) {
      this.urlListMunicipio = null;
      return;
    }

    this.urlListMunicipio = environment.urlApiUsuario + `Municipio/admin/idUnidadeFederativa/${idUnidadeFederativa}`;
    this.model.get('idMunicipio')?.enable();
  }

  /**
   * Busca endereco no ViaCEP e popula logradouro, bairro, UF e municipio.
   */
  buscarCep(): void {
    if (this.isLoadingCep) return;

    const cep: string = (this.model.get('cep')?.value ?? '').toString().replace(/\D/g, '');
    if (cep.length < 8) return;

    // Limpa estado anterior para evitar residuo de uma busca previa que ja nao reflete o CEP atual.
    this.model.get('idUnidadeFederativa')?.setValue(null);
    this.model.get('idMunicipio')?.setValue(null);
    this.preloadedUnidadeFederativa = [];
    this.preloadedMunicipio = [];

    this.isLoadingCep = true;
    this.utilService.getAddressByCEP(cep).subscribe({
      next: (res: CEPCorreios) => {
        this.isLoadingCep = false;
        if (!res || !res.cep) {
          this.alertService.show('Aviso', 'CEP não encontrado.', AlertType.warning);
          return;
        }

        this.model.patchValue({
          logradouro: res.logradouro ?? '',
          complemento: res.complemento ?? '',
          bairro: res.bairro ?? '',
        });

        const ufAlvo = (res.uf ?? '').trim().toUpperCase();
        const ufMatch = this._listaUnidadeFederativa?.find(
          u => (u.uf ?? '').trim().toUpperCase() === ufAlvo
        );
        if (!ufMatch) return;

        this.preloadedUnidadeFederativa = [ufMatch];
        this.model.get('idUnidadeFederativa')?.setValue(ufMatch.idUnidadeFederativa);
        this.urlListMunicipio =
          environment.urlApiUsuario +
          `Municipio/admin/idUnidadeFederativa/${ufMatch.idUnidadeFederativa}`;
        this.model.get('idMunicipio')?.enable();

        if (!res.localidade) return;

        // O endpoint admin filtra `municipio.nome` com Unaccent server-side mas compara
        // com o input "as is". Se mandarmos "São Paulo" o LIKE nao casa com "sao paulo".
        // Removemos acentos antes de enviar para garantir o match.
        const buscaCidade = this.removerAcentos(res.localidade.trim());

        this.selectPesquisavelService
          .getSelectValues<Municipio>(this.urlListMunicipio, buscaCidade)
          .subscribe({
            next: cidades => {
              const ibgeAlvo = (res.ibge ?? '').trim();
              const cidadeMatch =
                cidades.find(c => (c.codIbge ?? '').trim() === ibgeAlvo) ?? cidades[0];
              if (!cidadeMatch) return;
              this.preloadedMunicipio = [cidadeMatch];
              this.model.get('idMunicipio')?.setValue(cidadeMatch.idMunicipio);
            },
          });
      },
      error: () => {
        this.isLoadingCep = false;
      },
    });
  }

  private removerAcentos(texto: string): string {
    return texto.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // ── Dados fiscais ─────────────────────────────────────────────────────────

  /** A Inscrição Estadual só existe para quem apura ICMS. */
  public get isContribuinteIcms(): boolean {
    return this.idSituacaoContribuinteEmpresaControl.value === SituacaoContribuinteEmpresaEnum.ContribuinteIcms;
  }

  public get isContribuinteExclusivoIbsCbs(): boolean {
    return (
      this.idSituacaoContribuinteEmpresaControl.value === SituacaoContribuinteEmpresaEnum.ContribuinteExclusivoIbsCbs
    );
  }

  public get ajudaSituacaoContribuinteEmpresa(): string {
    return (
      this.textoAjudaSituacaoContribuinteEmpresa[
        this.idSituacaoContribuinteEmpresaControl.value as SituacaoContribuinteEmpresaEnum
      ] ?? ''
    );
  }

  public get ajudaInscricaoEstadual(): string {
    return this.isContribuinteIcms
      ? 'Necessária para emissão de nota fiscal de produto'
      : 'A ausência da Inscrição Estadual é o que caracteriza este enquadramento perante a SEFAZ.';
  }

  private onSituacaoContribuinteEmpresaChange(): void {
    if (!this.isContribuinteIcms) this.model.get('inscricaoEstadual')?.setValue(null);
    this.aplicarEstadoInscricaoEstadual(true);
  }

  /**
   * Habilitada só para contribuinte de ICMS. O required entra apenas quando o usuário escolhe
   * essa situação nesta sessão: exigir na carga travaria o Salvar das empresas que já eram
   * contribuintes e nunca informaram a inscrição. Mesma regra de Configurações > Empresa.
   *
   * @param escolhidoAgora true quando vem da troca da situação, não da carga da tela.
   */
  private aplicarEstadoInscricaoEstadual(escolhidoAgora: boolean): void {
    const inscricaoEstadual = this.model.get('inscricaoEstadual');
    if (!inscricaoEstadual) return;

    if (this.isContribuinteIcms) inscricaoEstadual.enable({ emitEvent: false });
    else inscricaoEstadual.disable({ emitEvent: false });

    const exigir = this.isContribuinteIcms && escolhidoAgora;
    inscricaoEstadual.setValidators(exigir ? [Validators.required] : []);
    inscricaoEstadual.updateValueAndValidity({ emitEvent: false });
    if (exigir) inscricaoEstadual.markAsTouched();
  }

  /**
   * O campo aceita valor aberto: o usuário pode escolher do catálogo ou ter um código gravado
   * que ainda não esteja nele (digitado livremente em outra tela). Como o select pesquisável
   * só exibe/seleciona itens presentes em `[preloadedOptions]`/`[offlineList]`/resultado da API,
   * alimentamos `preloadedCnae` com o item gravado para ele aparecer selecionado — do catálogo
   * quando encontrado, ou sintetizado a partir do próprio texto gravado quando não.
   */
  private carregarCnaeSelecionado(valorGravado: string | null): void {
    const texto = (valorGravado ?? '').toString().trim();

    if (!texto) {
      this.preloadedCnae = [];
      this.model.get('cnaePrincipal')?.setValue(null, { emitEvent: false });
      return;
    }

    // Preserva o valor gravado desde já, mesmo que a busca abaixo não encontre nada — nunca
    // silenciosamente perder um CNAE que o cliente já tinha cadastrado.
    this.preloadedCnae = [{ id: 0, codigo: texto, descricao: texto }];
    this.model.get('cnaePrincipal')?.setValue(texto, { emitEvent: false });

    const codigoLimpo = texto.replace(/\D/g, '');
    if (codigoLimpo.length !== 7) return;

    this.motorFiscalLookupService.getCnaes(codigoLimpo).subscribe(lista => {
      const item = lista.find(x => (x.codigo ?? '').replace(/\D/g, '') === codigoLimpo);
      if (!item) return;

      this.preloadedCnae = [item];
      this.model.get('cnaePrincipal')?.setValue(item.codigo, { emitEvent: false });
    });
  }

  /**
   * Um código de subclasse é gravado canônico, só com os 7 dígitos — venha do catálogo ou
   * digitado com máscara. Qualquer outro valor aberto é gravado exatamente como foi digitado.
   */
  private normalizarCnae(valor: string | null | undefined): string | null {
    const texto = (valor ?? '').toString().trim();
    if (!texto) return null;

    const digitos = texto.replace(/\D/g, '');
    const pareceCodigo = digitos.length === 7 && /^[\d\s.\-/]+$/.test(texto);

    return pareceCodigo ? digitos : texto;
  }

  private normalizarTexto(valor: string | null | undefined): string | null {
    const texto = (valor ?? '').toString().trim();
    return texto.length ? texto : null;
  }

  /**
   * A coluna é `date`. Montar/ler a data por componentes evita o deslocamento de um dia que
   * o parse ISO causaria em UTC-03 (`new Date('2009-03-12')` cai em 11/03 às 21h locais).
   */
  private converterDateParaDataApi(data: Date | null): string | null {
    if (!data) return null;
    const valor = new Date(data);
    if (isNaN(valor.getTime())) return null;
    const ano = valor.getFullYear();
    const mes = `${valor.getMonth() + 1}`.padStart(2, '0');
    const dia = `${valor.getDate()}`.padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  private converterDataApiParaDate(valor: Date | string | null): Date | null {
    if (!valor) return null;
    const texto = valor.toString().substring(0, 10);
    const [ano, mes, dia] = texto.split('-').map(Number);
    if (!ano || !mes || !dia) return null;
    return new Date(ano, mes - 1, dia);
  }

  public get idEmpresaGrupoControl(): FormControl {
    return this.model.get('idEmpresaGrupo') as FormControl;
  }

  public get idRevendaControl(): FormControl {
    return this.model.get('idRevenda') as FormControl;
  }

  public get listaTimezoneControl(): FormControl {
    return this.model.get('listaTimezone') as FormControl;
  }

  public get idUnidadeFederativaControl(): FormControl {
    return this.model.get('idUnidadeFederativa') as FormControl;
  }
  public get idMunicipioControl(): FormControl {
    return this.model.get('idMunicipio') as FormControl;
  }

  public get cnaePrincipalControl(): FormControl {
    return this.model.get('cnaePrincipal') as FormControl;
  }

  public get idRegimeApuracaoIrpjControl(): FormControl {
    return this.model.get('idRegimeApuracaoIrpj') as FormControl;
  }

  public get idRegimeTributarioControl(): FormControl {
    return this.model.get('idRegimeTributario') as FormControl;
  }

  public get idSituacaoContribuinteEmpresaControl(): FormControl {
    return this.model.get('idSituacaoContribuinteEmpresa') as FormControl;
  }
}
